import forEach from 'lodash/forEach'

const searchMenu = (event) => {
  const wrapper = document.querySelector('html')
  const opened = wrapper.classList.contains('search--open')
  const selected = event ? event.currentTarget : null
  const magnifier = document.querySelector('.search__button--open')
  const topnav = document.querySelector('.topnav')
  const search = document.querySelector('.search')
  const searchButton = document.querySelector('.search-click-button')

  if (selected && selected.classList.contains('search__button--close')) {
    wrapper.classList.toggle('search--open', false)
    magnifier.style.display = 'flex'
    topnav.style.display = 'flex'
    search.classList.remove('search--border')
    if (searchButton) searchButton.style.display = 'none'
  } else if (selected && opened && selected.classList.contains('search__button--open')) {
    goSearch()
  } else {
    wrapper.classList.toggle('search--open', true)
    setTimeout(() => {
      const searchBox = document.querySelector('.search__box')
      if (searchBox) {
        searchBox.focus()
      }
    }, 50)
    magnifier.style.display = 'none'
    topnav.style.display = 'none'
    search.classList.add('search--border')
    if (searchButton) searchButton.style.display = 'flex'
  }
}

const goSearch = () => {
  const box = document.querySelector('.search__box')

  if (box.value && box.value.trim().length > 1) {
    window.location.href = `${box.getAttribute('data-url')}?k=${box.value}`
  }
}

const goSearchMobile = () => {
  const box = document.querySelector('.search__box--mobile')

  if (box.value && box.value.trim().length > 1) {
    window.location.href = `${box.getAttribute('data-url')}?k=${box.value}`
  }
}

const searchOnKeyPress = (e) => {
  if (e.keyCode === 13 && e.target.value && e.target.value.trim().length > 1) {
    window.location.href = `${e.target.getAttribute('data-url')}?k=${e.target.value}`
  }
}

document.addEventListener('DOMContentLoaded', () => {
  forEach(document.querySelectorAll('.search__button'), (item) => {
    item.addEventListener('click', (event) => {
      searchMenu(event)
    })
  })

  document.querySelectorAll('.search__box').forEach(item => item.addEventListener('keypress', searchOnKeyPress))

  const searchButton = document.querySelector('.search-click-button')
  const searchMobileButton = document.querySelector('.search__go')

  if (searchButton) {
    searchButton.style.display = 'none'

    searchButton.addEventListener('click', () => {
      goSearch()
    })
  }

  if (searchMobileButton) {
    searchMobileButton.addEventListener('click', () => {
      goSearchMobile()
    })
  }
})

export default searchMenu
